import useSWR from "swr";
import { useCallback } from "react";
import useAuthenticatedAxios from "./use-authenticated-axios";

export default function useScripts() {
  const axios = useAuthenticatedAxios();

  // Fetch available scripts
  const { data, error, isLoading, mutate } = useSWR(
    "/admin/scripts",
    async (url) => {
      const response = await axios.get(url);
      return response.data;
    },
  );

  // Run a script with arguments
  const runScript = useCallback(
    async (scriptPath, args = {}) => {
      const response = await axios.post("/admin/scripts", {
        script: scriptPath,
        args,
      });
      return response.data;
    },
    [axios],
  );

  return {
    scripts: data?.scripts || {},
    isLoading,
    error,
    runScript,
    mutate,
  };
}
